import { render, staticRenderFns } from "./therapy.vue?vue&type=template&id=0a4292ba&scoped=true&"
import script from "./therapy.vue?vue&type=script&lang=js&"
export * from "./therapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4292ba",
  null
  
)

export default component.exports